<template>
  <div class="dsv2-spec-header">
    <div class="dsv2-spec-header__cover">
      <img :src="selectedSpec.coverImage" alt="" />
    </div>
    <div class="dsv2-spec-header__main">
      <div class="dsv2-spec-header__name" v-if="displayName">{{ displayName }}</div>
      <div class="dsv2-spec-header__price" v-if="selectedSpec.isShowPrice !== false">
        <span class="dsv2-spec-header__price-num">{{ selectedSpec.showPrice }}</span>
        <span class="dsv2-spec-header__price-unit">{{ selectedSpec.cardPointTypeUnit || '点' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'specHeader',
  props: {
    selectedSpec: {
      type: Object,
      default: function () {
        return {}
      }
    },
    productName: {
      type: String,
      default: ""
    }
  },
  computed: {
    displayName() {
      const spec = this.selectedSpec || {};
      return this.productName || spec.productName || spec.specifications || spec.specName || spec.name || "";
    },
  }
}
</script>

<style lang="scss" scoped>
.dsv2-spec-header {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 82px;
  padding: 10px 32px 8px 2px;
  box-sizing: border-box;
}

.dsv2-spec-header__cover {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f6f8;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.dsv2-spec-header__main {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dsv2-spec-header__name {
  font-size: 16px;
  line-height: 22px;
  color: #202124;
  font-weight: 500;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 6px;
}

.dsv2-spec-header__price {
  display: flex;
  align-items: baseline;
  color: #ff5000;
}

.dsv2-spec-header__price-num {
  font-size: 18px;
  line-height: 1;
  font-weight: 600;
}

.dsv2-spec-header__price-unit {
  margin-left: 4px;
  font-size: 13px;
  line-height: 1;
}
</style>